import { take, put, select, fork } from 'redux-saga/effects'
import { REHYDRATE } from 'redux-persist'
import { setShouldRequestMonthlySummary } from '../_BETA/requestSchedule'
import { LOGOUT_SUCCESS } from '../auth/actionTypes'

import { loadReportData /* , loadSampleData */ } from './actionCreators'
import {
  LOAD_REPORT_DATA_REQUEST,
  LOAD_REPORT_DATA_SUCCESS
} from './actionTypes'

export function* watchLoadReportData () {
  while (true) {
    const { shouldRequestMonthlySummary } = yield select((state: Insite.AppState) => state.requestSchedule)

    if (shouldRequestMonthlySummary) {
      const { user } = yield select((state: Insite.AppState) => state.auth)
      const { label: site } = yield select((state: Insite.AppState) => state.betaSelections.activeSite)

      // NOTE: Uncomment to test against static, local data
      // yield put(loadSampleData(user, site))

      // NOTE: Comment when testing with above static data
      yield put(loadReportData(user, site) as any)

      yield take(LOAD_REPORT_DATA_SUCCESS)

      yield put(setShouldRequestMonthlySummary(false))
    }

    yield take(LOAD_REPORT_DATA_REQUEST)
  }
}

export function* monthlySummarySagaFlow (): Generator<any, any, any> {
  yield take(REHYDRATE)

  while (true) {
    yield take(LOAD_REPORT_DATA_REQUEST)

    const watchLoadReportDataTask = yield fork(watchLoadReportData)

    yield take(LOAD_REPORT_DATA_SUCCESS)

    yield take(LOGOUT_SUCCESS)

    yield watchLoadReportDataTask.cancel()
  }
}
